import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { collection, query, orderBy, limit, getDocs, startAfter } from "firebase/firestore";
import { db } from "../../firebase/config"; // Adjust based on your setup

// export const fetchReviews = createAsyncThunk(
//   "reviews/fetchReviews",
//   async ({ productId, lastDoc }, { rejectWithValue }) => {
//     try {
//       const reviewsRef = collection(db, "products", productId, "reviews");
//       let q = query(reviewsRef, orderBy("createdAt", "desc"), limit(5));

//       if (lastDoc) {
//         q = query(reviewsRef, orderBy("createdAt", "desc"), startAfter(lastDoc), limit(5));
//       }

//       const querySnapshot = await getDocs(q);
//       const reviews = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       const newLastDoc = querySnapshot.docs[querySnapshot.docs.length - 1] || null;

//       return { reviews, newLastDoc };
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// const reviewsSlice = createSlice({
//   name: "reviews",
//   initialState: {
//     reviews: [],
//     lastDoc: null,
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     resetReviews: (state) => {
//       state.reviews = [];
//       state.lastDoc = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchReviews.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchReviews.fulfilled, (state, action) => {
//         state.loading = false;
//         state.reviews = [...state.reviews, ...action.payload.reviews];
//         state.lastDoc = action.payload.newLastDoc;
//       })
//       .addCase(fetchReviews.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { resetReviews } = reviewsSlice.actions;
// export default reviewsSlice.reducer;
export const fetchInitialReviews = createAsyncThunk(
    "reviews/fetchInitialReviews",
    async (productId, { rejectWithValue }) => {
      try {
        const reviewsRef = collection(db, "products", productId, "reviews");
        const q = query(reviewsRef, orderBy("createdAt", "desc"), limit(5));
  
        const querySnapshot = await getDocs(q);
        const reviews = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        const newLastDoc = querySnapshot.docs[querySnapshot.docs.length - 1] || null;
  
        return { reviews, newLastDoc };
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  
  // Fetch more reviews (Pagination)
  export const fetchMoreReviews = createAsyncThunk(
    "reviews/fetchMoreReviews",
    async ({ productId, lastDoc }, { rejectWithValue }) => {
      try {
        if (!lastDoc) return { reviews: [], newLastDoc: null }; // Prevent unnecessary fetch
  
        const reviewsRef = collection(db, "products", productId, "reviews");
        const q = query(reviewsRef, orderBy("createdAt", "desc"), startAfter(lastDoc), limit(5));
  
        const querySnapshot = await getDocs(q);
        const reviews = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        const newLastDoc = querySnapshot.docs[querySnapshot.docs.length - 1] || null;
  
        return { reviews, newLastDoc };
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  
  const reviewsSlice = createSlice({
    name: "reviews",
    initialState: {
      reviews: [],
      lastDoc: null,
      loading: false,
      error: null,
    },
    reducers: {
      resetReviews: (state) => {
        state.reviews = [];
        state.lastDoc = null;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchInitialReviews.pending, (state) => {
          state.loading = true;
        })
        .addCase(fetchInitialReviews.fulfilled, (state, action) => {
          state.loading = false;
          state.reviews = action.payload.reviews;
          state.lastDoc = action.payload.newLastDoc;
        })
        .addCase(fetchInitialReviews.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
        .addCase(fetchMoreReviews.pending, (state) => {
          state.loading = true;
        })
        .addCase(fetchMoreReviews.fulfilled, (state, action) => {
          state.loading = false;
          state.reviews = [...state.reviews, ...action.payload.reviews];
          state.lastDoc = action.payload.newLastDoc;
        })
        .addCase(fetchMoreReviews.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    },
  });
  
  export const { resetReviews } = reviewsSlice.actions;
  export default reviewsSlice.reducer;
  